// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_GetTemplatesByFranchisesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for get_templates_by_franchises() /mensagens_programadas/get_templates_by_franchises
 * Returns an array of WhatsApp message templates.
 */
import type { MensagensProgramadas_TemplateRow } from './MensagensProgramadas_TemplateRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadas_GetTemplatesByFranchisesResponseDados {
dados: MensagensProgramadas_TemplateRow[]
}

export type MensagensProgramadas_GetTemplatesByFranchisesResponse = ApiResponse<MensagensProgramadas_GetTemplatesByFranchisesResponseDados>;

registerResponseContract('MensagensProgramadas_GetTemplatesByFranchisesResponse', {
  dados: {
    type: 'array',
    required: true,
    items: {
      template_id:        { type: 'number',  required: true },
      template_name:      { type: 'string',  required: true },
      template_content:   { type: 'string',  required: true },
      template_type:      { type: 'string',  required: true },
      template_media_url: { type: 'string',  required: false },
      is_active:          { type: 'number',  required: true },
      created_at:         { type: 'string',  required: true },
      updated_at:         { type: 'string',  required: true },
    },
  },
})
